
/**
 * The set of available actions that can be
 * dispatched to mutate the form state.
 */
export const FormStateActions = {
  SET_FORM_ERRORS: 'SET_FORM_ERRORS',
  SET_FIELD: 'SET_FIELD',
  SET_FIELD_ERROR: 'SET_FIELD_ERROR',
  SET_FIELD_VALID: 'SET_FIELD_VALID',
  SET_FIELD_TOUCHED: 'SET_FIELD_TOUCHED',
  SET_IS_VALIDATING: 'SET_IS_VALIDATING',
  SET_IS_SUBMITTING: 'SET_IS_SUBMITTING',
  RESET_FORM: 'RESET_FORM',
  SET_FIELDS: 'SET_FIELDS',
};
